module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "svg-sprite-73eb2de96aa4d32e2310be8fc749a2c5.svg#twitter",
      toString: function () {
        return this.url;
      }
    }